// @flow

import _ from 'lodash';
import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import * as Zap from 'app/entities/Zap';
import ZapMover from 'app/zap-mover/components/ZapMover';

import type { Dispatch } from 'app/common/types';

const mapStateToProps = (state, { fromAccountId, toAccountId }) => {
  return {
    fromAccountId,
    // Get _all_ zaps ids for moving and not just the ones
    // that match the current `query`. This 1) provides a
    // full count of _all_ the selected zaps and 2) provides
    // a full array of _all_ zaps to move in `onMoveZaps` below.
    selectedZapIds: Zap.selectors.all
      .inAccount(fromAccountId, state)
      .filter(_.negate(Zap.selectors.isDraft))
      .filter(Zap.selectors.isSelectedForMoving)
      .map(Zap.selectors.id),
    toAccountId,
    toAccountName: Account.selectors.name(
      Account.selectors.all.entity(toAccountId, state)
    ),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onMoveZaps(fromId, toId, zapIds) {
      dispatch(Zap.actions.moveZaps(toId, zapIds));
    },
  };
};

export default _.flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ZapMover);
